var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCombLongRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 89,
    viewBox: "0 0 106 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 9,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 106 9)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.666,
    cy: 49.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5113 60.999H64.9113V47.199C64.9113 43.799 64.9113 36.399 54.6613 36.399C50.8613 36.399 47.1113 37.549 44.4613 40.249L47.6113 43.399C49.2113 41.899 51.5113 40.899 54.0113 40.899C57.2113 40.899 59.5113 42.449 59.5113 45.399V46.049H58.0113C52.0113 46.049 42.9113 46.599 42.9113 54.399C42.9113 59.149 47.2113 61.599 51.6613 61.599C54.8613 61.599 57.6613 60.399 59.3613 57.699H59.5113V60.999ZM59.1613 51.599C59.1613 54.949 57.2113 57.099 53.1113 57.099C51.1613 57.099 48.9113 56.149 48.9113 53.949C48.9113 50.499 54.6113 50.249 57.9113 50.249H59.1613V51.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 96 16.999)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 79 16.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 62 16.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 45 16.999)",
    fill: "#52B3A7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 28 16.999)",
    fill: "#52B3A7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 11 16.999)",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5L8 2.99999C8 1.34314 9.34315 -1.1268e-05 11 -1.10507e-05L93 -2.97687e-07C94.6569 -8.04172e-08 96 1.34315 96 3L96 5.00001L8 5Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCombLongRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-comb-long-right.d59ee3810d656ec08055d8541191c46f.svg";
export { ForwardRef as ReactComponent };